module.exports = __webpack_public_path__ + "static/equipment-crane-9dbb8f50ae5d2b74890e0d50a4f281d2.jpg";